<section *ngIf="run as item" class="page">
  <a class="back-link" routerLink="/runs"><i class="pi pi-arrow-left"></i> All function runs</a>
  <header><div><p>Execution detail</p><h2>{{ item.functionName }}</h2><span>{{ item.source }} · {{ item.functionType }}</span></div><span [class]="statusClass(item.status)">{{ item.status }}</span></header>

  <section class="summary-grid" aria-label="Run summary">
    <article><span>Service</span><strong>{{ item.source }}</strong></article>
    <article><span>Function type</span><strong>{{ item.functionType }}</strong></article>
    <article><span>Trigger source</span><strong>{{ item.triggerSource }}</strong></article>
    <article><span>Priority</span><strong>{{ item.priority }}</strong></article>
    <article><span>Retry attempt</span><strong>{{ item.attemptCount }} / {{ item.maxRetryCount }}</strong></article>
    <article><span>Storage</span><strong>{{ item.isArchived ? 'Archive' : 'Recent' }}</strong></article>
  </section>

  <article class="panel">
    <div class="panel-heading"><p>Function configuration</p><h3>Definition schedule</h3></div>
    <dl class="details">
      <div class="wide"><dt>URL</dt><dd class="wrap">{{ item.url }}</dd></div>
      <div><dt>Last run</dt><dd>{{ item.definitionLastRunAtUtc ? (item.definitionLastRunAtUtc | date:'medium') : '—' }}</dd></div>
      <div><dt>Next run</dt><dd>{{ item.definitionNextRunAtUtc ? (item.definitionNextRunAtUtc | date:'medium') : '—' }}</dd></div>
      <div><dt>Status</dt><dd>{{ item.status }}</dd></div>
      <div><dt>Configured timeout</dt><dd>{{ timeoutLabel(definition?.timeoutMilliseconds) }}</dd></div>
    </dl>
  </article>

  <article class="panel">
    <div class="panel-heading"><p>Timing and outcome</p><h3>Execution</h3></div>
    <p class="execution-error" *ngIf="item.failureReason"><strong>Failure details:</strong> {{ item.failureReason }}</p>
    <dl class="details">
      <div><dt>Queued</dt><dd>{{ item.queuedAtUtc | date:'medium' }}</dd></div>
      <div><dt>Started</dt><dd>{{ item.startedAtUtc ? (item.startedAtUtc | date:'medium') : '—' }}</dd></div>
      <div><dt>Completed</dt><dd>{{ item.completedAtUtc ? (item.completedAtUtc | date:'medium') : '—' }}</dd></div>
      <div><dt>Execution duration</dt><dd>{{ duration(item) }}</dd></div>
      <div><dt>Next retry</dt><dd>{{ item.nextAttemptAtUtc ? (item.nextAttemptAtUtc | date:'medium') : '—' }}</dd></div>
    </dl>
  </article>

  <article class="panel">
    <div class="panel-heading log-heading"><div><p>Execution log</p><h3>Safe run events</h3></div><button type="button" [disabled]="logsLoading" (click)="loadLogs()"><i class="pi pi-refresh" [class.pi-spin]="logsLoading"></i> Refresh</button></div>
    <p class="execution-error" *ngIf="logsError">{{ logsError }}</p>
    <ol class="run-logs" *ngIf="logs.length; else noLogs"><li *ngFor="let log of logs" [class.warning]="log.level === 'Warning'" [class.error]="log.level === 'Error'"><time>{{log.occurredAtUtc | date:'medium'}}</time><span>{{log.level}}</span><div><strong>{{log.eventType}}</strong><p>{{log.message}}</p></div></li></ol>
    <ng-template #noLogs><p class="empty" *ngIf="!logsError">{{ logsLoading ? 'Loading execution logs…' : 'No execution events were recorded.' }}</p></ng-template>
  </article>

  <article class="panel users-panel">
    <div class="panel-heading"><p>User accountability</p><h3>Changed users</h3></div>
    <p class="execution-error" *ngIf="usersError">{{ usersError }}</p>
    <div class="table-wrap" *ngIf="users?.items?.length; else usersState">
      <table><thead><tr><th>Email</th><th>Source</th><th>Change</th><th>Old roles</th><th>New roles</th><th>Created</th><th>Updated</th><th></th></tr></thead>
        <tbody><tr *ngFor="let user of users?.items">
          <td><span class="truncate" [title]="user.email || ''">{{ user.email || '—' }}</span></td><td>{{ user.source }}</td><td>{{ user.changeType }}</td>
          <td><span class="truncate" [title]="roles(user.oldRoles)">{{ roles(user.oldRoles) }}</span></td><td><span class="truncate" [title]="roles(user.roles)">{{ roles(user.roles) }}</span></td>
          <td class="date-cell">{{ user.createdAtUtc | date:'medium' }}</td><td class="date-cell">{{ user.updatedAtUtc ? (user.updatedAtUtc | date:'medium') : '—' }}</td>
          <td><a class="detail-link" [routerLink]="['/user-imports', user.publicId]">View details</a></td>
        </tr></tbody>
      </table>
    </div>
    <ng-template #usersState><p class="empty" *ngIf="!usersError">{{ usersLoading ? 'Loading changed users…' : 'No changed users were recorded.' }}</p></ng-template>
    <app-pagination *ngIf="users" [page]="usersPaging.page" [pageSize]="usersPaging.pageSize" [totalCount]="users.totalCount" [loading]="usersLoading" itemLabel="users" (paginationChange)="changeUsersPagination($event)" />
  </article>
</section>
<p class="execution-error" *ngIf="error">{{ error }}</p>
